
import axios from 'axios';
import config from '../../config';
import { Error, API } from './base';


class Application {
    constructor(obj){
        Object.assign(this, obj)
    }
}

class ApplicationsAPI extends API {

    constructor(token, accountId) {
        super(token);
        this.accountId = accountId;
    }

    urlCreate() {
        // https://sinexiar.com/smre/
        return config.get("re.urlGlobal") + "management/clients/applications";
    }

    // https://sinexiar.com/smre/management/
    urlManagement() {
        return config.get("re.management");
    }

    urlApplication(idApp) {
        // https://sinexiar.com/smre/management/clients/applications/{app_id}
        const url = this.urlManagement() + "clients/applications/"+idApp;
        return url;
    }

    urlApplicationsByAccount(idAccount) {
        const url = this.urlManagement() + "clients/accounts/"+idAccount+"/applications";
        return url;
    }

    baseUrl() {
        return config.get("re.url");
    }

    authToken() {
        return config.get("auth0.token");
    }

    getAll(idAccount) {
        return new Promise((resolve, reject) => {
            axios.get(this.urlApplicationsByAccount(idAccount), this._getHeaders()).then(response => {
                if (response.status === 200) {
                    const dbs = [];
                    response.data.applications.forEach(a => {
                        dbs.push(new Application(a));
                    });
                    resolve(dbs);
                } else {
                    const err = new Error(response.status, "Failed to fetch applications", JSON.stringify(response.data));
                    reject(err);
                }

            }).catch(err => {
                reject(err);
            });
        })
    }

    get(idApp) {
        return new Promise((resolve, reject) => {
            axios.get(this.urlApplication(idApp), this._getHeaders()).then(response => {
                
                if (response.status === 200) {
                    resolve(new Application(response.data));
                } else {
                    const err = new Error(response.status, "Failed to fetch application", JSON.stringify(response.data));
                    reject(err);
                }

            }).catch(err => {
                reject(err);
            });
        })
    }

    getDBs(appId) {
        return new Promise((resolve, reject) => {
            axios.get(`${this.baseUrl()}dbsofapps?app_id=${appId}` , this._getHeaders()).then(response => {
                if (response.status === 200) {
                    resolve(response.data.dbsofapps);
                } else {
                    const err = new Error(response.status, "Failed to fetch applications", JSON.stringify(response.data));
                    reject(err);
                }
            }).catch(err => {
                reject(err);
            });
        })
    }

    // Update an Application given its ID
    update(app) {
        return new Promise((resolve, reject) => {
            axios.put(this.urlApplication(app.id), app, this._getHeaders(),
            ).then(response => {
                if (response.status >= 200 && response.status < 400) {
                    resolve();
                } else {
                    const err = new Error(response.status, "Failed to update application", JSON.stringify(response.data));
                    reject(err);
                }
            }).catch(err => {
                debugger
                reject(new Error(err.response.status, "Failed to update the application", JSON.stringify(err.response.data.message)));
            });
        });
    }

    // Logical delete of an application given its ID.
    delete(id) {
        return new Promise((resolve, reject) => {
            // https://sinexiar.com/smre/management/clients/applications/{app_id}
            axios.delete(this.urlApplication(id), this._getHeaders()).then(response => {
                if (response.status >= 200 && response.status < 400) {
                    resolve();
                } else {
                    const err = new Error(response.status, "Failed to delete application", JSON.stringify(response.data));
                    reject(err);
                }
            }).catch(err => {
                reject(err);
            });
        });
    }

    create(a) {
        return new Promise((resolve, reject) => {
            axios.post(this.urlCreate(), a, this._getHeaders(),
            ).then(response => {
                if (response.status === 201) {
                    resolve(new Application(response.data));
                } else {
                    const err = new Error(response.status, "Failed to create application", JSON.stringify(response.data));
                    reject(err);
                }
            }).catch(err => {

                // TOUSE This is a way to handle bakcend error to present to users handled by the "ErrorMessage" component.
                reject(new Error(err.response.status, "Failed to create application", JSON.stringify(err.response.data.message)));
            });
        });
    }

    runStack(a) {
        return new Promise((resolve, reject) => {
            axios.post(this.urlCreate(), a, this._getHeaders(),
            ).then(response => {
                if (response.status === 201) {
                    resolve(new Application(response.data.application));
                } else {
                    const err = new Error(response.status, "Failed to create application", JSON.stringify(response.data));
                    reject(err);
                }
            }).catch(err => {
                reject(err);
            });
        });
    }

    getToken({code, secret, apikey}) {
        return new Promise((resolve, reject) => {
            const body= {
                grant_type: "authorization_code",
                redirect_uri: `${window.location.origin}/application/authorize`,
                code,
                client_secret: secret,
                client_id : apikey
            }
            console.log("body", body)
            axios.post(this.authToken(), body, null,
            ).then(response => {
                if (response.status === 200) {
                    resolve(response.data);
                } else {
                    const err = new Error(response.status, "Failed to create token", JSON.stringify(response.data));
                    reject(err);
                }
            }).catch(err => {
                reject(err);
            });
        });
    }
}

export {
    ApplicationsAPI, Application
};